import type { ReactNode } from 'react';

export const symbol_edit_attributes: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M279-280q-83 0-141.5-58.5T79-480q0-83 58.5-141.5T279-680h400q83 0 141.5 58.5T879-480q0 83-58.5 141.5T679-280H279Zm0-60h400q58.33 0 99.17-40.76 40.83-40.77 40.83-99Q819-538 778.17-579q-40.84-41-99.17-41H279q-58.33 0-99.17 40.76-40.83 40.77-40.83 99Q139-422 179.83-381q40.84 41 99.17 41Zm64-69 103-103q8-7.91 8-18.45 0-10.55-8-18.55t-18.18-8q-10.18 0-17.82 8l-88 87-27-27q-7.64-8-17.82-8T259-489.07q-8 7.93-8 18.5t8 18.57l42 43q9 9 21 9t21-9Zm137-71Z"
		/>
	</svg>
);
